import { API, Space } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  stripeToken: string;
  receiptExtra?: string;
};

const [useReplaceCreditCard, replaceCreditCard] = createAsyncAction(
  "billing/replaceCreditCard",
  async ({ spaceId, stripeToken, receiptExtra }: Args) => {
    const res = await API.call<{ space: Space }>({
      endpoint: `spaces/${spaceId}/payment-source/`,
      method: "PUT",
      normalize: false,
      data: {
        stripe_token: stripeToken,
        receipt_extra: receiptExtra,
      },
    });

    return { result: res.result.space.card };
  }
);

export default useReplaceCreditCard;
export { replaceCreditCard };
